// src/utils/apiUrl.js
// Resolves the backend API base URL at runtime so the same build artifact
// works correctly in both SWA environments after a slot swap.
//
// Priority:
//   1. Build-time VITE_API_URL override (used by .env.development* so local
//      dev can point at http://localhost:8080). Wins everywhere.
//   2. Browser hostname routing:
//        *-staging.<...>.azurestaticapps.net  -> api-staging.ibetoni.fi
//        staging.<...>                        -> api-staging.ibetoni.fi
//        anything else                        -> api.ibetoni.fi
//   3. Non-browser fallback (SSR, tests without window stub): production API.

const STAGING = "https://api-staging.ibetoni.fi";
const PROD = "https://api.ibetoni.fi";

export function isStagingHost(hostname) {
    if (!hostname) return false;
    return hostname.includes("-staging.") || hostname.startsWith("staging.");
}

export function detectApiUrl() {
    const buildTimeOverride = import.meta.env.VITE_API_URL;
    if (buildTimeOverride) return buildTimeOverride;
    if (typeof window !== "undefined" && isStagingHost(window.location?.hostname)) {
        return STAGING;
    }
    return PROD;
}

export const API_URL = detectApiUrl();
